// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 .members_right__bQXVJ {
  display: flex;
  align-items: center;
  gap: 20px;
}
.members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 .members_right__bQXVJ .members_date__PhxJ6 {
  display: flex;
  align-items: center;
  gap: 4px;
}
.members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 .members_right__bQXVJ .members_date__PhxJ6 img,
.members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 .members_right__bQXVJ .members_date__PhxJ6 svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 .members_right__bQXVJ .members_date__PhxJ6 span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}
.members_membersPageWrp__2EhFB .members_dataGridWrp__RXiVJ {
  padding: 0 24px;
}
.members_membersPageWrp__2EhFB .members_listToolbar__FqXzu {
  margin-bottom: 12px;
}
.members_membersPageWrp__2EhFB .members_listToolbar__FqXzu .members_listToolbarRow__k3nxt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.members_membersPageWrp__2EhFB .members_listToolbar__FqXzu .members_listToolbarRow__k3nxt .members_filteredChips__Xj8mX {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.members_membersPageWrp__2EhFB .members_listToolbar__FqXzu .members_listToolbarRow__k3nxt .members_filteredChips__Xj8mX .members_filteredChipsLabel__AEvAC {
  font: var(--body-font-four);
  font-weight: 600;
  color: var(--primary-Text);
  display: inline-block;
  margin-right: 8px;
}
.members_membersPageWrp__2EhFB .members_listToolbar__FqXzu .members_listToolbarRow__k3nxt .members_filterBtns__yY\\+mw {
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1 1;
  justify-content: flex-end;
}

.members_InviteModalInner__-tpiU .members_csvAddMemberRow__fw1Gy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
}
.members_InviteModalInner__-tpiU .members_addMemberFieldWrp__Q\\+988 {
  max-height: 300px;
  overflow-y: auto;
}
.members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
}
.members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding-top: 2px;
}
.members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B .members_input__g\\+e3b {
  width: 100%;
}
.members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B .members_role__2QwDo {
  min-width: 170px;
}
.members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B .members_deleteBtn__OzWUf {
  width: 40px;
  height: 40px;
}
.members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B .members_deleteBtn__OzWUf button {
  padding: 10px;
}

.members_permissionsCard__K3Bxn {
  background-color: #faf4f2 !important;
  border-radius: 1rem !important;
  padding: 0.5rem !important;
  box-shadow: none !important;
  border: 1px solid #f0e8e5 !important;
}

.members_permissionsHeader__OqkJe {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
}

.members_permissionsTitle__QCnF0 {
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  color: #1a1a1a;
  margin: 0 !important;
}

.members_permissionsActions__-PZsp {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.members_actionBtn__nHomM {
  font-size: 0.875rem !important;
  text-transform: none !important;
  color: #7CA6BD !important;
  padding: 0.375rem 0.75rem !important;
  min-width: auto !important;
}
.members_actionBtn__nHomM:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.members_permissionsList__r8ko9 {
  display: flex;
  flex-direction: column;
}

.members_permissionItem__DE7ui {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.members_permissionLabel__Uup-L {
  font-size: 0.9375rem !important;
  color: #374151 !important;
  font-weight: 500 !important;
}

@media (max-width: 767px) {
  .members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 {
    padding: 16px;
  }
  .members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 .members_right__bQXVJ {
    gap: 12px;
  }
  .members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 .members_right__bQXVJ button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
  .members_membersPageWrp__2EhFB .members_dataGridWrp__RXiVJ {
    padding: 0 16px;
  }
  .members_InviteModalInner__-tpiU .members_csvAddMemberRow__fw1Gy button {
    font-size: 12px !important;
  }
}
@media (max-width: 600px) {
  .members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B {
    flex-wrap: wrap;
  }
  .members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B .members_role__2QwDo {
    order: 3;
    width: 100%;
  }
  .members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B .members_deleteBtn__OzWUf {
    width: 35px;
    height: 35px;
    flex-shrink: 0;
  }
  .members_InviteModalInner__-tpiU .members_addMemberFieldRow__juuGn .members_row__EPR7B .members_deleteBtn__OzWUf button {
    min-height: auto;
    width: 100%;
    padding: 2px;
    height: 100%;
  }
  .members_InviteModalInner__-tpiU .members_row__EPR7B > div:first-child {
    flex: 1 1;
  }
  .members_InviteModalInner__-tpiU .members_row__EPR7B > div:first-child .members_input__g\\+e3b {
    max-width: 100%;
  }
}
@media (max-width: 425px) {
  .members_membersPageWrp__2EhFB .members_membersHeader__5mLF3 .members_right__bQXVJ .members_date__PhxJ6 span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/members/members.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;AAWC;EACC,eAAA;AATF;AAYC;EACC,mBAAA;AAVF;AAYE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAVH;AAYG;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAVJ;AAYI;EACC,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,iBAAA;AAVL;AAcG;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AAZJ;;AAmBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAhBF;AAmBC;EACC,iBAAA;EACA,gBAAA;AAjBF;AAoBC;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAlBF;AAoBE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AAlBH;AAoBG;EACC,WAAA;AAlBJ;AAqBG;EACC,gBAAA;AAnBJ;AAsBG;EACC,WAAA;EACA,YAAA;AApBJ;AAsBI;EACC,aAAA;AApBL;;AA2BA;EACC,oCAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,oCAAA;AAxBD;;AA2BA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAxBD;;AA2BA;EACC,8BAAA;EACA,2BAAA;EACA,cAAA;EACA,oBAAA;AAxBD;;AA2BA;EACC,aAAA;EACA,WAAA;EACA,mBAAA;AAxBD;;AA2BA;EACC,8BAAA;EACA,+BAAA;EACA,yBAAA;EACA,oCAAA;EACA,0BAAA;AAxBD;AA0BC;EACC,gDAAA;AAxBF;;AA4BA;EACC,aAAA;EACA,sBAAA;AAzBD;;AA4BA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAzBD;;AA4BA;EACC,+BAAA;EACA,yBAAA;EACA,2BAAA;AAzBD;;AA4BA;EAEE;IACC,aAAA;EA1BD;EA4BC;IACC,SAAA;EA1BF;EA4BE;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EA1BH;EA+BA;IACC,eAAA;EA7BD;EAmCC;IACC,0BAAA;EAjCF;AACF;AAsCA;EAGG;IACC,eAAA;EAtCF;EAwCE;IACC,QAAA;IACA,WAAA;EAtCH;EAyCE;IACC,WAAA;IACA,YAAA;IACA,cAAA;EAvCH;EAyCG;IACC,gBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EAvCJ;EA6CA;IACC,SAAA;EA3CD;EA6CC;IACC,eAAA;EA3CF;AACF;AAgDA;EAKK;IACC,aAAA;EAlDJ;AACF","sourcesContent":[".membersPageWrp {\r\n\t.membersHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.inviteBtn {\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.dataGridWrp {\r\n\t\tpadding: 0 24px;\r\n\t}\r\n\r\n\t.listToolbar {\r\n\t\tmargin-bottom: 12px;\r\n\r\n\t\t.listToolbarRow {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\tgap: 10px;\r\n\r\n\t\t\t.filteredChips {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t.filteredChipsLabel {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\tmargin-right: 8px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.filterBtns {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tflex: 1;\r\n\t\t\t\tjustify-content: flex-end;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.InviteModalInner {\r\n\t.csvAddMemberRow {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 5px;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\r\n\t.addMemberFieldWrp {\r\n\t\tmax-height: 300px;\r\n\t\toverflow-y: auto;\r\n\t}\r\n\r\n\t.addMemberFieldRow {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 15px;\r\n\t\tmargin-bottom: 15px;\r\n\t\twidth: 100%;\r\n\r\n\t\t.row {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: 100%;\r\n\t\t\tpadding-top: 2px;\r\n\r\n\t\t\t.input {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\r\n\t\t\t.role {\r\n\t\t\t\tmin-width: 170px;\r\n\t\t\t}\r\n\r\n\t\t\t.deleteBtn {\r\n\t\t\t\twidth: 40px;\r\n\t\t\t\theight: 40px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tpadding: 10px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.permissionsCard {\r\n\tbackground-color: #faf4f2 !important;\r\n\tborder-radius: 1rem !important;\r\n\tpadding: 0.5rem !important;\r\n\tbox-shadow: none !important;\r\n\tborder: 1px solid #f0e8e5 !important;\r\n}\r\n\r\n.permissionsHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding-bottom: 0.5rem;\r\n}\r\n\r\n.permissionsTitle {\r\n\tfont-size: 1.125rem !important;\r\n\tfont-weight: 600 !important;\r\n\tcolor: #1a1a1a;\r\n\tmargin: 0 !important;\r\n}\r\n\r\n.permissionsActions {\r\n\tdisplay: flex;\r\n\tgap: 0.5rem;\r\n\talign-items: center;\r\n}\r\n\r\n.actionBtn {\r\n\tfont-size: 0.875rem !important;\r\n\ttext-transform: none !important;\r\n\tcolor: #7CA6BD !important;\r\n\tpadding: 0.375rem 0.75rem !important;\r\n\tmin-width: auto !important;\r\n\r\n\t&:hover {\r\n\t\tbackground-color: rgba(0, 0, 0, 0.04) !important;\r\n\t}\r\n}\r\n\r\n.permissionsList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.permissionItem {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 0.5rem 0;\r\n}\r\n\r\n.permissionLabel {\r\n\tfont-size: 0.9375rem !important;\r\n\tcolor: #374151 !important;\r\n\tfont-weight: 500 !important;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.membersPageWrp {\r\n\t\t.membersHeader {\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t.right {\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.dataGridWrp {\r\n\t\t\tpadding: 0 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t.InviteModalInner {\r\n\t\t.csvAddMemberRow {\r\n\t\t\tbutton {\r\n\t\t\t\tfont-size: 12px !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 600px) {\r\n\t.InviteModalInner {\r\n\t\t.addMemberFieldRow {\r\n\t\t\t.row {\r\n\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t.role {\r\n\t\t\t\t\torder: 3;\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.deleteBtn {\r\n\t\t\t\t\twidth: 35px;\r\n\t\t\t\t\theight: 35px;\r\n\t\t\t\t\tflex-shrink: 0;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\tmin-height: auto;\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\tpadding: 2px;\r\n\t\t\t\t\t\theight: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.row > div:first-child {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.input {\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.membersPageWrp {\r\n\t\t.membersHeader {\r\n\t\t\t.right {\r\n\t\t\t\t.date {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"membersPageWrp": `members_membersPageWrp__2EhFB`,
	"membersHeader": `members_membersHeader__5mLF3`,
	"right": `members_right__bQXVJ`,
	"date": `members_date__PhxJ6`,
	"dataGridWrp": `members_dataGridWrp__RXiVJ`,
	"listToolbar": `members_listToolbar__FqXzu`,
	"listToolbarRow": `members_listToolbarRow__k3nxt`,
	"filteredChips": `members_filteredChips__Xj8mX`,
	"filteredChipsLabel": `members_filteredChipsLabel__AEvAC`,
	"filterBtns": `members_filterBtns__yY+mw`,
	"InviteModalInner": `members_InviteModalInner__-tpiU`,
	"csvAddMemberRow": `members_csvAddMemberRow__fw1Gy`,
	"addMemberFieldWrp": `members_addMemberFieldWrp__Q+988`,
	"addMemberFieldRow": `members_addMemberFieldRow__juuGn`,
	"row": `members_row__EPR7B`,
	"input": `members_input__g+e3b`,
	"role": `members_role__2QwDo`,
	"deleteBtn": `members_deleteBtn__OzWUf`,
	"permissionsCard": `members_permissionsCard__K3Bxn`,
	"permissionsHeader": `members_permissionsHeader__OqkJe`,
	"permissionsTitle": `members_permissionsTitle__QCnF0`,
	"permissionsActions": `members_permissionsActions__-PZsp`,
	"actionBtn": `members_actionBtn__nHomM`,
	"permissionsList": `members_permissionsList__r8ko9`,
	"permissionItem": `members_permissionItem__DE7ui`,
	"permissionLabel": `members_permissionLabel__Uup-L`
};
export default ___CSS_LOADER_EXPORT___;
